import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useIsBrowser from 'hooks/useIsBrowser';

const useIsAdvancedSearch = () => {
  const isBrowser = useIsBrowser();
  const location = useLocation();

  const isAdvancedSearch = useMemo(() => {
    const pathname = location?.pathname ?? '';
    return pathname === '/search/';
  }, [location]);

  return isBrowser ? isAdvancedSearch : false;
};

export default useIsAdvancedSearch;
